import { render, staticRenderFns } from "./PaperTabbed.vue?vue&type=template&id=2863dd71&"
import script from "./PaperTabbed.vue?vue&type=script&lang=js&"
export * from "./PaperTabbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports